// TODO: Merge with Sequence class in animation/SequenceAnimation.js

import StepAnimation from "@frog/source/engine/animating/StepAnimation.js"

export default class Sequence {
    static seek(sequence) {
        if(sequence.steps == undefined) {
            return
        }
        Sequence.skip(sequence)

        // // Skip to the next "important step"
        // // or until their are no steps left.
        // while(sequence.steps.length > 0) {
        //     if(sequence.steps[0].isImportant) {
        //         break
        //     }
        //     if(sequence.steps[0].animation != undefined
        //     && sequence.steps[0].animation.isImportant == true) {
        //         break
        //     }
        //     Sequence.skip(sequence)
        // }
    }
    static skip(sequence) {
        const step = sequence.steps[0]
        let toBeRemoved = true

        if(step != undefined) {
            if(step.isUnskippable) {
                toBeRemoved = false
            }
            if(step.func instanceof Function) {
                step.func()
            }
            if(step?.animation?.keyframes != undefined) {
                step.animation.keyframes.forEach((keyframe) => {
                    if(keyframe.function != undefined) {
                        keyframe.function()
                    }
                    if(keyframe.func != undefined) {
                        keyframe.func()
                    }
                    // TODO: keyframe.do and keyframe.func
                })
                if(step.animation.minduration != undefined
                && step.time < step.animation.minduration) {
                    step.time = step.animation.minduration
                    toBeRemoved = false

                    StepAnimation.executeAnimation({
                        "stage": step.stage,
                        "animation": step.animation,
                        "currentDuration": step.animation.minduration
                    })
                }
            }
            // step.deltastages.forEach((deltastage) => {
            //     if(deltastage.function instanceof Function) {
            //         deltastage.function()
            //     }
            // })
        }

        if(toBeRemoved) {
            sequence.steps.shift()

            if(sequence.isLooping == true) {
                sequence.steps.push(StepAnimation.instantiate(step))
            }
        }
    }
    static skipall(sequence) {
        if(sequence?.steps != undefined) {
            while(sequence.steps.length > 0) {
                const step = sequence.steps[0]
                if(step.isUnskippable == true) break
                if(step.isIgnorable != true && step.func instanceof Function) step.func()
                sequence.steps.shift()
            }
        }
    }
}
